import { format } from 'date-fns';
import { matchesAlertTypeFilter } from './alertLabels';

export const filterAlerts = (
  alerts,
  { candidateSearch = '', dateFilter = '', alertType = 'all' } = {},
) => {
  const search = candidateSearch.trim().toLowerCase();

  return (alerts ?? []).filter((alert) => {
    const matchesCandidate = !search || [
      alert.candidateName,
      alert.currentRole,
      alert.description,
    ].some((value) => value?.toLowerCase().includes(search));

    const matchesDate = !dateFilter
      || (alert.createdAt
        && format(new Date(alert.createdAt), 'yyyy-MM-dd') === dateFilter);

    const matchesType = matchesAlertTypeFilter(alert.alertType, alertType);

    return matchesCandidate && matchesDate && matchesType;
  });
};
